enum ErrorResponseCodes {
  ERROR_POPUP_OK = 'ERROR_POPUP_OK',
  ERROR_SESSION_INVALID = 'ERROR_SESSION_INVALID',
}
export default ErrorResponseCodes;
